import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import huTranslation from './assets/i18n/hu.json';
import enTranslation from './assets/i18n/en.json';
import frTranslation from './assets/i18n/fr.json';
import deTranslation from './assets/i18n/de.json';
import LanguageDetector from 'i18next-browser-languagedetector';

const formatLanguage = (language: string): string => {
  if (language.includes('_')) {
    return language.split('_')[0];
  }
  return language;
};

void i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      hu: {
        translation: huTranslation
      },
      en: {
        translation: enTranslation
      },
      fr: {
        translation: frTranslation
      },
      de: {
        translation: deTranslation
      }
    },
    fallbackLng: 'en',
    compatibilityJSON: 'v3',
    detection: {
      convertDetectedLanguage: formatLanguage
    }
  });

export default i18n;
